/**
 * The "resolves to" hint under the Azure Storage server row: the Blob endpoint the connection will REALLY dial,
 * from the same resolution the main process builds its clients with (`azureStorageEndpointResolution.ts`) — an
 * Advanced endpoint override verbatim, the Azurite preset's 127.0.0.1 endpoints, a pasted endpoint URL — instead of
 * a `https://<account>.blob.core.windows.net` guess from the account name alone.
 */
import { resolvedServiceEndpoint } from '@/core/engines/azureStorageEndpointResolution';
import type { ConnectionFormValues } from './connectionFormSchema';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ConnectionFormApi = any;

export function storageEndpointHint(values: Partial<ConnectionFormValues>): string | undefined {
  return resolvedServiceEndpoint(
    { server: values.server ?? '', azureStorageEndpoints: values.azureStorageEndpoints, azureStorageEmulator: values.azureStorageEmulator },
    'blob',
  );
}

export function AzureStorageEndpointHint({ form }: { form: ConnectionFormApi }) {
  return (
    <form.Subscribe selector={(state: { values: Partial<ConnectionFormValues> }) => storageEndpointHint(state.values)}>
      {(resolved: string | undefined) =>
        resolved ? (
          <p className="mt-1 text-xs text-muted-foreground" data-testid="azure-storage-endpoint-hint">
            resolves to <span className="font-mono">{resolved}</span>
          </p>
        ) : null
      }
    </form.Subscribe>
  );
}
